import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nft-post-page',
  templateUrl: './nft-post-page.component.html',
  styleUrls: ['./nft-post-page.component.scss'],
})
export class NftPostPageComponent {
  isLeftBarMobileOpen: boolean = false;

  constructor() {}
}
